export default {
  BT_HDP: "แฮนดิแคป  | HDP",
  BT_OU: "สูง/ต่ำ | O/U",
  BT_ML: "มันนี่ไลน์",
  BT_1X2: "1X2",
  BT_1X2HDP: "แฮนดิแคป 3 ทาง",
  BT_CS: "ทายผลสกอร์",
  BT_OE: "คี่/คู่ | O/E",
  BT_DC: "สองโอกาส",
  BT_HTFT: "ครึ่งเวลา/เต็มเวลา",
  BT_FGLG: "ประตูแรก/สุดท้าย",
  BT_TG: "จำนวนประตูทั้งหมด",
  BT_OR: "ทายผลผู้ชนะ",
  BT_ORZ: "ทายผลผู้ชนะ",

  BT_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BT_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BT_CL: "ไม่เสียประตู",
  BT_DNB: "เสมอไม่เดิมพัน",
  BT_DNBH: "ครึ่งเวลา เสมอไม่เดิมพัน",
  BT_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BT_TWTN: "ชนะโดยไม่เสียประตู",

  BT_HDPF: "เต็มเวลา แฮนดิแคป  | เต็มเวลา. HDP",
  BT_OUF: "เต็มเวลา สูง/ต่ำ | เต็มเวลา O/U",
  BT_MLF: "เต็มเวลา มันนี่ไลน์",
  BT_1X2F: "เต็มเวลา 1X2",
  BT_1X2HDPF: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BT_CSF: "เต็มเวลา ทายผลสกอร์",
  BT_OEF: "เต็มเวลา คี่/คู่ | เต็มเวลา O/E",
  BT_DCF: "เต็มเวลา สองโอกาส",
  BT_FGLGF: "เต็มเวลา ประตูแรก/สุดท้าย",
  BT_TGF: "เต็มเวลา จำนวนประตูทั้งหมด",

  BT_HDPH: "ครึ่งเวลา แฮนดิแคป  | ครึ่งเวลา. HDP",
  BT_OUH: "ครึ่งเวลา สูง/ต่ำ | ครึ่งเวลา O/U",
  BT_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BT_1X2H: "ครึ่งเวลา 1X2",
  BT_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BT_CSH: "ครึ่งเวลา ทายผลสกอร์",
  BT_OEH: "ครึ่งเวลา  คี่/คู่ | ครึ่งเวลา O/E",
  BT_DCH: "ครึ่งเวลา สองโอกาส",
  BT_FGLGH: "ครึ่งเวลา ประตูแรก/สุดท้าย",
  BT_TGH: "ครึ่งเวลา จำนวนประตูทั้งหมด",
  BT_O: "สูง",
  BT_U: "ต่ำ",
  BT_ODD: "คี่",
  BT_EVEN: "คู่",

  BT_HDPOU: "แฮนดิแคป & สูง/ต่ำ",
  BT_PARLAY: "มิกซ์ พาร์เลย์",
  BT_FT: "เต็มเวลา. ",
  BT_1H: "ครึ่งแรก. ",
  BT_2H: "ครึ่งหลัง. ",

  BT_FG: "ประตูแรก",
  BT_LG: "ประตูสุดท้าย",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "ไม่มีประตู",
  BT_HY: "เจ้าบ้าน ไม่เสียประตู",
  BT_HN: "เจ้าบ้าน เสียประตู",
  BT_AY: "ทีมเยือน ไม่เสียประตู",
  BT_AN: "ทีมเยือน เสียประตู",
  BT_H: "เจ้าบ้าน",
  BT_A: "ทีมเยือน",
  BT_D: "เสมอ",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "ใช่",
  BT_N: "ไม่มี",

  BT_LIVE: "สด",
  BT_HT: "ครึ่งแรก",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",

  BT_FT1: "เต็มเวลา.1",
  BT_FT2: "เต็มเวลา.2",
  BT_FTX: "เต็มเวลา.X",
  BT_HT1: "ครึ่งเวลา.1",
  BT_HT2: "ครึ่งเวลา.2",
  BT_HTX: "ครึ่งเวลา.X",

  BT_BOTH: "ทั้งคู่",
  BT_ONE: "หนึ่ง",

  BS_HDP: "เต็มเวลา แฮนดิแคป",
  BS_HDPH: "ครึ่งเวลา แฮนดิแคป",
  BS_OU: "เต็มเวลา สูง/ต่ำ",
  BS_OUH: "ครึ่งเวลา สูง/ต่ำ",
  BS_OE: "เต็มเวลา คี่/คู่",
  BS_OEH: "ครึ่งเวลา คี่/คู่",
  BS_1X2: "เต็มเวลา 1X2",
  BS_1X2H: "ครึ่งเวลา 1X2",
  BS_ML: "เต็มเวลา มันนี่ไลน์",
  BS_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BS_1X2HDP: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BS_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BS_CS: "เต็มเวลา ทายผลสกอร์",
  BS_CSH: "ครึ่งเวลา ทายผลสกอร์",
  BS_DC: "เต็มเวลา สองโอกาส",
  BS_DCH: "ครึ่งเวลา สองโอกาส",
  BS_FGLG: "เต็มเวลา ประตูแรก/สุดท้าย",
  BS_FGLGH: "ครึ่งเวลา ประตูแรก/สุดท้าย",
  BS_TG: "เต็มเวลา จำนวนประตูทั้งหมด",
  BS_TGH: "ครึ่งเวลา จำนวนประตูทั้งหมด",
  BS_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BS_HTFT: "ครึ่งเวลา/เต็มเวลา",
  BS_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BS_CL: "ไม่เสียประตู",
  BS_DNB: "เสมอไม่เดิมพัน",
  BS_DNBH: "ครึ่งเวลา เสมอไม่เดิมพัน",
  BS_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BS_TWTN: "ชนะโดยไม่เสียประตู",
  BS_OR: "ทายผลผู้ชนะ",
  BS_ORZ: "ทายผลผู้ชนะ",
  
  LOT_BS: "ใหญ่/เล็ก",
  LOT_BIG: "ใหญ่",
  LOT_SMALL: "เล็ก",
  LOT_OE: "คี่/คู่",
  LOT_ODD: "คี่",
  LOT_EVEN: "คู่",
  LOT_OU: "สูง/ต่ำ",
  LOT_OVER: "สูง",
  LOT_UNDER: "ต่ำ",
  LOT_FT: "เต็มเวลา",
  LOT_HT: "ครึ่งเวลา",

  BT_ALLBT: "ประเภทการเดิมพันทั้งหมด",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "วิธีชนะ",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "ชนะ",
  GH_1X20: "ชนะ",
  GH_1X2HDP: "อันดับ/แสดง",
  GH_1X2HDP2: "อันดับ",
  GH_1X2HDP4: "แสดง",
  GH_OVER: "สูงกว่า (4,5,6)",
  GH_UNDER: "ต่ำกว่า (1,2,3)",
  GH_ODD: "คี่ (1,3,5)",
  GH_EVEN: "คู่ (2,4,6)",
  GH_OU1: "สูงกว่า (4,5,6)",
  GH_OU2: "ต่ำกว่า (1,2,3)",
  GH_OE1: "คี่ (1,3,5)",
  GH_OE2: "คู่ (2,4,6)",

  GX_1X2: "ชนะ",
  GX_1X20: "ชนะ",
  GX_1X2HDP: "อันดับ/แสดง",
  GX_1X2HDP2: "อันดับ",
  GX_1X2HDP4: "แสดง",
  GX_OVER: "สูงกว่า (7-12)",
  GX_UNDER: "ต่ำกว่า (1-6)",
  GX_ODD: "คี่ (1,3,5,7,9,11)",
  GX_EVEN: "คู่ (2,4,6,8,10,12)",
  GX_OU1: "สูงกว่า (7-12)",
  GX_OU2: "ต่ำกว่า (1-6)",
  GX_OE1: "คี่ (1,3,5,7,9,11)",
  GX_OE2: "คู่ (2,4,6,8,10,12)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "สูงกว่า (3,4,5)",
  GC_UNDER: "ต่ำกว่า (0,1,2)",
  GC_ODD: "คี่ (1,3,5)",
  GC_EVEN: "คู่ (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "ลูกแรก",
  GC_1X20: "เพื่อชนะ",
  GC_ML: "ลูกแรก",
  GC_1X2: "เพื่อชนะ",
  GC_OU1: "สูงกว่า (3,4,5)",
  GC_OU2: "ต่ำกว่า (0,1,2)",
  GC_OE1: "คี่ (1,3,5)",
  GC_OE2: "คู่ (0,2,4)",

  GR_RED: "แดง (1)",
  GR_YELLOW: "เหลือง (2)",
  GR_BLUE: "น้ำเงิน (3)",
  GR_GREEN: "เขียว (4)",
  GR_OVER: "สูงกว่า (3,4)",
  GR_UNDER: "ต่ำกว่า (1,2)",
  GR_ODD: "คี่ (1,3)",
  GR_EVEN: "คู่ (2,4)",
  GR_SINGLE: "เดี่ยว",
  GR_PAIR: "คู่",
  GR_TRIPS: "สาม",
  GR_ADVANCED: "ผ่าน",
  GR_ELIMINATED: "ตกรอบ",
  GR_HIT1: "ถูก 1",
  GR_HIT2: "ถูก 2",
  GR_PERFECT: "สมบูรณ์แบบ",
  GR_MLHOME: "ผ่าน",
  GR_MLAWAY: "ตกรอบ",
  GR_1X2FT1: "เดี่ยว",
  GR_1X2FTX: "คู่",
  GR_1X2FT2: "สาม",
  GR_ML1: "ผ่าน",
  GR_ML2: "ตกรอบ",
  GR_1X21: "เดี่ยว",
  GR_1X22: "สาม",
  GR_1X23: "คู่",
  GR_OU1: "สูงกว่า (3,4)",
  GR_OU2: "ต่ำกว่า (1,2)",
  GR_OE1: "คี่ (1,3)",
  GR_OE2: "คู่ (2,4)",

  ROOM_A: "เปิด",
  ROOM_0: "เปิดใช้งาน",
  ROOM_1: "ปิด",
  ROOM_2: "ยกเลิก",
  ROOM_3: "จบ",
  ROOM_4: "หยุดการเดิมพัน",
  ROOM_10: "ทั้งหมด",

  ROOM_T0: "ทั้งหมด",
  ROOM_T1: "ห้องสาธารณะ",
  ROOM_T2: "ห้องส่วนตัว",
  ROOM_T3: "เล่นเพื่อรับรางวัล",

  joinRoom1: "เข้าร่วมห้องสาธารณะ",
  joinRoom2: "เข้าร่วมห้องส่วนตัว",
  joinRoom3: "เข้าร่วมห้องเล่น",
  createRoom1: "สร้างห้องสาธารณะ",
  createRoom2: "สร้างห้องส่วนตัว",
  createRoom3: "สร้างห้องเล่น",
  Champion: "แชมป์",
  FirstRunnerUp: "อันดับ 1 รองชนะเลิศ",
  SecondRunnerUp: "อันดับ 2 รองชนะเลิศ",

  BT_OEHM: "บ้าน คี่/คู่",
  BT_OEHMH: "HT. บ้าน คี่/คู่",
  BT_OEAW: "ทีมเยือน คี่/คู่",
  BT_OEAWH: "HT. ทีมเยือน คี่/คู่",

  BS_OEHM: "FT. บ้าน คี่/คู่",
  BS_OEHMH: "HT. บ้าน คี่/คู่",
  BS_OEAW: "FT. ทีมเยือน คี่/คู่",
  BS_OEAWH: "HT. ทีมเยือน คี่/คู่",

  MB_OVER: "สูงกว่า (4,5,6)",
  MB_UNDER: "ต่ำกว่า (1,2,3)",
  MB_ODD: "คี่ (1,3,5)",
  MB_EVEN: "คู่ (2,4,6)",

  BS_1X2OU: "1X2 + O/U",
  BT_1X2OU: "1X2 + O/U",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Double Chance + O/U",
  BT_DCOU: "Double Chance + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "O/U + O/E",
  BT_OUOE: "O/U + O/E",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + O/E",
  BT_HTFTOE: "HT/FT + O/E",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Winning Margin",
  BT_WM: "Winning Margin",
  BK_H1: "บ้าน 1",
  BK_H2: "บ้าน 2",
  BK_H3Up: "บ้าน 3+",
  BK_A1: "ทีมเยือน 1",
  BK_A2: "ทีมเยือน 2",
  BK_A3Up: "ทีมเยือน 3+",
  BK_D: "เสมอ (ยกเว้น 0-0)",
  BK_NG: "ไม่มีประตู",

  BS_ETG: "Exact Total Goal",
  BT_ETG: "Exact Total Goal",
  BS_EHTG: "Exact Home Total Goal",
  BT_EHTG: "Exact Home Total Goal",
  BS_EATG: "Exact Away Total Goal",
  BT_EATG: "Exact Away Total Goal",
  BS_ETGH: "HT. Exact Total Goal",
  BT_ETGH: "HT. Exact Total Goal",
  BS_EHTGH: "HT. Exact Home Total Goal",
  BT_EHTGH: "HT. Exact Home Total Goal",
  BS_EATGH: "HT. Exact Away Total Goal",
  BT_EATGH: "HT. Exact Away Total Goal",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "สกอร์ HT/FT",
  BS_CSHTFT: "สกอร์ HT/FT",
  BT_ETGHTFT: "ประตูรวม HT/FT",
  BS_ETGHTFT: "ประตูรวม HT/FT",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "ผู้ชนะรอบที่ 1",
  CF_R_2_W: "ผู้ชนะรอบที่ 2",
  CF_R_3_W: "ผู้ชนะรอบที่ 3",
  CF_MLHOME: "ทีมเจ้าบ้านชนะ",
  CF_MLAWAY: "ทีมเยือนชนะ",
  CF_EVEN: "การแข่งขัน 2 รอบ",
  CF_ODD: "การแข่งขัน 3 รอบ",
  CF_ML1: "ทีมเจ้าบ้านชนะ",
  CF_ML2: "ทีมเยือนชนะ",
  CF_ML: "ชนะเดี่ยว",
  CF_CS: "คะแนนที่ถูกต้อง",
  CF_OE: "คู่/คี่",
  CF_0: "เสมอ",
  CF_1: "เจ้าบ้าน",
  CF_2: "เยือน",
  CF_OE1: "คู่",
  CF_OE2: "คี่",
    
  EF8_R1_1STBOOM: "บูมแรก รอบที่ 1",
  EF8_R2_1STBOOM: "บูมแรก รอบที่ 2",
  EF8_R3_1STBOOM: "บูมแรก รอบที่ 3",
  EF8_0: "-",
  EF8_1: "เจ้าบ้าน",
  EF8_2: "เยือน",

};